import { getProxiedServiceUrl, generateURL } from '@xengage/gw-portals-url-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';


const _getUrlQueryParams = (url) => {
    const splitRst = url.split('?');
    const params = {};

    if (splitRst[1]) {
        let query = splitRst[1];
        query = query.split('+').join(' ');

        const re = /[?&]?([^=]+)=([^&]*)/g;
        let tokens = [];

        tokens = re.exec(query);
        while (tokens !== null && tokens.length > 2) {
            const key = decodeURIComponent(tokens[1]);
            const value = decodeURIComponent(tokens[2]);
            params[key] = value;
            tokens = re.exec(query);
        }
    }

    return params;
}
export default class MLOnDemandDocumentService {
    static getForms(search, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('ondemanddocs'),
            'getForms', [search], additionalHeaders);
    }

    static createDraft(search, draft, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('ondemanddocs'),
            'createDraft', [search, draft], additionalHeaders);
    }
    
    static createDocument(draft, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('ondemanddocs'),
            'createDocument', [draft], additionalHeaders);
    }
    
    static getPotentialRecipients(policyNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('ondemanddocs'),
            'getPotentialRecipients', [policyNumber], additionalHeaders);
    }
    
    static getPrimarySigner(policyNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('ondemanddocs'),
            'getPrimarySigner', [policyNumber], additionalHeaders);
    }
    
    static getSpouseSigner(policyNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('ondemanddocs'),
            'getSpouseSigner', [policyNumber], additionalHeaders);
    }
    
    static sendDocumentUpdateToPC(reviewCaseId, xml, xmlvalidation, formPattern, policyNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('ondemanddocs'),
            'updateDocumentFromDraftEditor', [reviewCaseId, xml, xmlvalidation, formPattern, policyNumber], additionalHeaders);
    }

    static generateAndSendOnDemandDocumentperiod(jobNumber, isBundled ,email , declineRequestFromBatch, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('ondemanddocs'),
            'declineAndGenerateDeclinationDocument', [jobNumber, isBundled ,email , declineRequestFromBatch], additionalHeaders);
    }

    static getDocumentEditorLink(draftEditorUrl){
        const params = _getUrlQueryParams(draftEditorUrl);

        const newParams = {
            urlParam: params.reviewCaseId,
            ...params
        }
        return generateURL(getProxiedServiceUrl('documentEditor'), newParams);
    }
}
